import { render, staticRenderFns } from "./WBtnActivate.vue?vue&type=template&id=34ee4fe9&scoped=true&"
import script from "./WBtnActivate.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnActivate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee4fe9",
  null
  
)

export default component.exports